import type { MockDatabase } from './schema'

/** Merge new account fields for persisted DBs from before passkeys / recovery / trusted devices. */
export const normalizeMockDatabase = (db: MockDatabase): MockDatabase => {
  if (!db.account.passkeys) {
    db.account.passkeys = []
  }
  if (!db.account.recoveryCodes) {
    db.account.recoveryCodes = { remainingCount: 0, lastGeneratedAt: null }
  }
  if (!db.account.trustedDevices) {
    db.account.trustedDevices = []
  }

  if (!db.appCustomPermissions) {
    db.appCustomPermissions = []
  }

  for (const role of db.appRoles) {
    if (!role.customPermissionIds) {
      role.customPermissionIds = []
    }
  }

  return db
}
